module.exports = __webpack_public_path__ + "sprstatic/img/WORD.85daed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BidSecurity/WORD.png
// module id = PuQa
// module chunks = 2